import { Sunrise, Sunset, Clock } from 'lucide-react';
import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SunTimesSection = () => {
  const [sunTimes, setSunTimes] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSunTimes = async () => {
      try {
        const response = await axios.get(`${API}/sun/times`);
        setSunTimes(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching sun times:', error);
        setLoading(false);
      }
    };
    fetchSunTimes();
  }, []);

  return (
    <div className="content-card" data-testid="sun-times-section">
      <div className="card-header">
        <h2>
          <Sunrise size={20} className="inline" /> Today's Sun Times
        </h2>
      </div>
      <div className="card-content">
        {loading ? (
          <p className="loading-text">Loading...</p>
        ) : sunTimes ? (
          <div className="sun-times-container">
            <div className="sun-time-item">
              <Sunrise size={32} className="sun-icon sunrise-icon" />
              <div className="sun-time-details">
                <span className="sun-label">Sunrise</span>
                <span className="sun-time">{sunTimes.sunrise}</span>
              </div>
            </div>
            
            <div className="sun-time-item">
              <Sunset size={32} className="sun-icon sunset-icon" />
              <div className="sun-time-details">
                <span className="sun-label">Sunset</span>
                <span className="sun-time">{sunTimes.sunset}</span>
              </div>
            </div>
            
            <div className="sun-time-item">
              <Clock size={32} className="sun-icon daylight-icon" />
              <div className="sun-time-details">
                <span className="sun-label">Daylight</span>
                <span className="sun-time">{sunTimes.day_length}</span>
              </div>
            </div>
          </div>
        ) : (
          <p className="no-data">Sun times unavailable</p>
        )}
      </div>
    </div>
  );
};

export default SunTimesSection;